import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit, OnInit } from '@angular/core';
import { EPG_list } from '../iptv-epg/epg.interfaces';
import { SpatialNavigationService } from './spatial-navigation.service';
import { FormControl } from '@angular/forms';
import { map, debounceTime, filter, distinctUntilChanged } from 'rxjs/operators';

// Polyfill Mobile Drag&Drop
import {polyfill as MobileDragAndDrop} from "mobile-drag-drop";
// optional import of scroll behaviour
import {scrollBehaviourDragImageTranslateOverride} from "mobile-drag-drop/scroll-behaviour";

@Component({
  selector: 'iptv-editor',
  templateUrl: './iptv_editor.component.html',
  styleUrls: [ './iptv_editor.component.css' ]
})
/**
 * Редактор списка телеканалов для IPTV
 */
export class IPTVEditorComponent implements AfterViewInit, OnInit {
  /**
   * Выбранная группа.
   */
  @Input("groupSelected") set group_selected(group:ChannelsGroup) {
    this._group_selected = group;
    this.group_select(group);
  };
  get group_selected():ChannelsGroup {
    return this._group_selected;
  }
  private  _group_selected:ChannelsGroup = {id:1, name:"Test"};
  /**
   * Перемещаемая группа
   */
  public group_moved:ChannelsGroup = null;
  /**
   * ID группы, над которой стоит курсор с передвигаемым элементом
   */
  public group_over:number = null;
  /**
   * Массив каналов, который был выбран для передвижения, использованием CTRL
   */
  public channels_moved:Channel[] = [];
  /**
   * Список каналов, который отображается, в зависимости от выбранной группы или поисковой cтроки. Отображается не сам данный список, а делается фильтрация в Pipe, чтобы перемещения каналов, проходили в оригинальном списке.
   */
  public channelsFiltered:Channel[] = [];
  /**
   * Список каналов. Удаленные каналы, должны быть под группой group_id: null
   */
  @Input() channels:Channel[] = []
  /**
   * Группы каналов
   */
  @Input() groups:ChannelsGroup[] = []
  /**
   * Событие на изменение канала.
   */
  @Output("changeChannel") changeChannel = new EventEmitter<Channel>();
  /**
   * Событие при удалении канала.
   */
  @Output("removeChannel") removeChannel = new EventEmitter<Channel>();
  /**
   * Воспроизведение канала
   */
  @Output("playChannel") playChannel = new EventEmitter<Channel>();
  /**
   * Отобразить программу передач на день
   */
  @Output("epgDayChannel") epgDayChannel = new EventEmitter<Channel>();
  /**
   * Загрузить программу передач для передаваемых каналов. Используется при поиске каналов.
   */
  @Output("epgChannels") epgChannels = new EventEmitter<Channel[]>();
  /**
   * Событие при изменении группы
   */
  @Output("changeGroup") changeGroup = new EventEmitter<ChannelsGroup>();
  /**
   * Передаёт выбранную группу для отображения.
   */
  @Output("selectedGroup") selectedGroup = new EventEmitter<ChannelsGroup>();
  /**
   * Событие удаление группы каналов
   */
  @Output("groupRemoveEvent") groupRemoveEvent = new EventEmitter<ChannelsGroup>();
  /**
   * Событие очистки корзины
   */
  @Output("emptyTrashEvent") emptyTrashEvent = new EventEmitter<null>();
  /**
   * HTML элемент блока каналов, для прокрутки списка каналов в начало, при добавлении нового канала.
   */
  @ViewChild("channelsBlock", {static: true}) channelsBlock:ElementRef = null;
  /**
   * HTML элемент блока групп, для прокрутки списка групп в конец, при добавлении новой группы.
   */
  @ViewChild("groupsBlock", {static: true}) groupsBlock:ElementRef = null;
  /**
   * Таймер перемещения канала, по которому определяется, переместить ли канал в конец списка.
   * Следующие 3 свойства используются для быстрого перемещения канала в конец или начало списка,
   * используя резкое и короткое по времени, передвижение канала вниз или вверх по списку.
   */
  dragTimer:number = 0;
  /**
   * Индикатор начала перемещения канала.
   */
  dragChannelStarted:boolean = false;
  /**
   * Положение курсора по оси Y, во время начала перемещения
   */
  dragScreenY:number = 0;
  /**
   * Нажата ли кнопка SHIFT в заголовке списка каналов
   */
  shiftKey:boolean = false;
  /**
   * Нажата ли кнопка CTRL в заголовке списка каналов
   */
  ctrlKey:boolean = false;
  /**
   * Флаг отображения поисковой строки для каналов
   */
  showChannelsSearchInput:boolean = false;
  /**
   * Поле ввода поиска канала.
   */
  channelsSearh = new FormControl("");

  constructor (private _spatialNavigation:SpatialNavigationService){
    
  }

  ngAfterViewInit(){
    setTimeout(() => {
      // Ставим фокус на первом канале, чтобы можно было видеть кнопку Play
      const firstChannelElement = <HTMLLIElement>document.querySelector("#IPTV_Editor .channels ul li");
      if(firstChannelElement) firstChannelElement.focus();
    }, 1000); 

    MobileDragAndDrop({
        // Drag action delay on touch devices ("hold to drag" functionality, useful for scrolling draggable items). Defaults to no delay.
        holdToDrag: 500,
        // use this to make use of the scroll behaviour
        dragImageTranslateOverride: scrollBehaviourDragImageTranslateOverride
    });
  }

  ngOnInit(){
    // Обработчик поисковой строки по имени канала
    this.channelsSearh.valueChanges.pipe(
          map((search:string) => search.trim()),
          debounceTime(200),
          distinctUntilChanged(),
      ).subscribe((search:string)=>{
        this.channels_filter({search: search});
      });
  }
  /**
   * Фильтрация списка каналов по выбранной группе или поисковой строке
   * @param filter 
   */
  channels_filter(filter:{search?:string, group_id?:number | null}){
    this.channels_moved_truncate();
    if(typeof filter.group_id == "number" || filter.group_id === null ){
      this.channelsFiltered = this.channels.filter(channel => channel.group_id == filter.group_id);
    } else 
    if(typeof filter.search == "string" && filter.search.trim().length > 0){
      this.channelsFiltered = this.channels.filter( channel =>{
        return channel.name.toLowerCase().indexOf(filter.search.toLowerCase().toString()) > -1 ? true : false;
      });
      // Убираем выделенную группу
      this._group_selected = {id: -1, name: "Empty"};
    }
  }
  /**
   * Добавление канала
   */
  channel_add(e:MouseEvent){
    // Если не выбрана группа, значит производится поиск канала и тогда запрещаем добавление канала.
    if(this._group_selected.id === -1) return false;
    const channel = {name: "Добавленный канал", group_id: this.group_selected.id, url:"http://", tvg_id: "", icon: "", deleted: true, added: true};
    let index = -1;
    // Производим поиск индекса последнего канала в группе.
    this.channels.forEach((ch, i)=>{
                    if(ch.group_id === this.group_selected.id){
                      index = i;
                    }
                  });
    if(index > -1){
      this.channels.splice(index, 0, channel);
    } else {
      this.channels.splice(this.channels.length-1, 0, channel);
    }
    this.channelsFiltered.splice(this.channelsFiltered.length-1, 0, channel);
    // Анимация добавления канала
    setTimeout(() => {
      channel.deleted = false;
    }, 50);
    // Анимация кнопки добавления канала
    const element = <HTMLParagraphElement>e.currentTarget;
    element.classList.add("animation");
    setTimeout(() => {
      channel.added = false;
      element.classList.remove("animation");
    }, 500);
    // Прокручиваем каналы в начало списка.
    const channelsBlock = <HTMLElement>this.channelsBlock.nativeElement;
    try {
      channelsBlock.querySelector("li:last-child").scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    } catch (error) {
      channelsBlock.scrollTop = channelsBlock.scrollHeight - channelsBlock.clientHeight;
    }
  }
  /**
   * Удаление канала из группы  
   */
  channel_remove(ch:Channel) {
    // Кидаем сразу в корзину, иначе шлём слушателю удаляемый канал из корзины.
    if(ch.group_id !== null){
      // Присваиваем класс для анимации
      ch.deleted = true;
      setTimeout(()=>{
        ch.group_id = null
        ch.deleted = false;
        // Удаляем каналы из отображаемого списка.
        this.channelsFiltered.splice(this.channelsFiltered.indexOf(ch), 1);
        this._spatialNavigation.reset();
      }, 500);
    } else {
      this.removeChannel.emit(ch);
    }
  }
  /**
   * Полное Удаление канала из корзины
   * @param channel Channel
   */
  channel_trash_remove(channel:Channel){
    channel.deleted = true;
    setTimeout(()=>{
      channel.deleted = false;
      this._spatialNavigation.reset();
      this.channels.splice(this.channels.indexOf(channel),1);
    }, 500);
  }
  /**
   * Переименование канала
   */
  channel_rename(channel:Channel){
    this.changeChannel.emit(channel);
  }
  /**
   * Событие при начале перемещения канала
   * @param channel Канал, который начали перемещать.
   * @param e 
   */
  channel_dragstart(channel:Channel, e:DragEvent){ 
    e.dataTransfer.setData("text/plain", ""); // Обязательно для Mozilla
    setTimeout(() => { // Делаем очень малую задержку, так как перемещаемый объект сдвигается по X и если хватать объект за определенную область, перемещение сразу же останавливается.
      if(this.channels_moved.indexOf(channel) < 0){
        this.channels_moved.push(channel);
        channel.move = true;
      }
      const dragChannelIndex = this.channels.indexOf(channel);
      this.channels_moved.splice(0,0,...this.channels_moved.splice(this.channels_moved.indexOf(channel),1));
      this.channels_moved.forEach((channel:Channel)=>{
        this.channels.splice(this.channels.indexOf(channel),1);
      });
      this.channels.splice(dragChannelIndex,0, ...this.channels_moved);
    }, 1);
  }
  /**
   * Событие срабатывающее, когда перемещаемый канал, находится над ним.
   * @param channel Канал над которым проходит перемещение.
   * @param e 
   */
  channel_dragenter(channel:Channel, e:DragEvent|null){
      e && e.preventDefault();
      if(!channel.move) {
        // Инициализируем индикаторы для определения быстрого перемещения канала.
        if(this.dragChannelStarted == false && e){
          this.dragChannelStarted = true;
          this.dragTimer = Date.now();
          this.dragScreenY = e.screenY;
        } 
        setTimeout(() => { // Так как this.channel_dragstart запускается с задержкой, то и это событие запускаем с задержкой
          const indexEnter = this.channels.indexOf(channel);
          this.channels.splice(this.channels.indexOf(this.channels_moved[0]), this.channels_moved.length);
          this.channels.splice(indexEnter+1,0, ...this.channels_moved);
          this._spatialNavigation.reset();
        }, 2);
      }
  }
  /**
   * Событие, срабатывающее после того, как канал был отпущен.
   * @param e 
   */
  channel_dragend(e:DragEvent|null){
    if(this.channels_moved.length){

      if(this.dragChannelStarted){ // В мобильной версии при резком перемещении срабатывает событие dragend, а в настольной версии drop
        const deltaY = e.screenY - this.dragScreenY;
        // Если время перемещения канала меньше 100 мс и дальность перемещения больше 50px, то переносим канал в начало или конец списка.
        if((Date.now() - this.dragTimer) < 100 && Math.abs(deltaY) > 50){
          this.channel_dragenter(deltaY > 0 ? this.channels[this.channels.length -1] : this.channels[0], null);
        }
        this.dragChannelStarted = false;
      }

      this.channels_moved.forEach((channel:Channel)=>{
        channel.move = false;
        channel.moved = true;
      })
      setTimeout(() => { // По окончании анимации возвращаем исходные данные
        this.channels_moved.forEach((channel:Channel)=>{
          channel.moved = false;
        });
        this.channels_moved = [];
        this._spatialNavigation.reset();
      }, 300);
    }
    this.group_over = null;
  }
  /**
   * На канал бросается элемент. Необходимо для совместимости с Firefox так как для определения быстрого перемещения используется e.screenY, а FF в событие dragend возвращает 0
   * @param e 
   */
  channel_drop(e:DragEvent){
    if(this.dragChannelStarted){
      const deltaY = e.screenY - this.dragScreenY;
      // Если время перемещения канала меньше 100 мс и дальность перемещения больше 50px, то переносим канал в начало или конец списка.
      if((Date.now() - this.dragTimer) < 100 && Math.abs(deltaY) > 50){
        this.channel_dragenter(deltaY > 0 ? this.channels[this.channels.length -1] : this.channels[0], null);
      }
      this.dragChannelStarted = false;
    }
  }
  /**
   * Очистка массива выделенных каналов
   */
  private channels_moved_truncate(){
    this.channels_moved.forEach((channel:Channel)=>{
      channel.move = false;
    });
    this.channels_moved = [];
  }
  /**
   * Нажатие кнопки запуска воспроизведения канала.
   * @param channel 
   */
  channel_play(channel:Channel){
    this.playChannel.emit(channel);
    return false;
    // let serverUrl = "";
    //     if(channel.url.indexOf(":")>0){
    //         serverUrl = channel.url;
    //     } else {
    //         serverUrl = `${this.server}/${channel.url}/video.m3u8?token=${this.token}`;
    //     }
    // /** @todo Указать путь к файлу видеоплеера */
    // const data = JSON.stringify({url: serverUrl, name: channel.name});
    // let url = `http://${location.host}/iptv/videoplayer/?`+encodeURIComponent(data);
    // (<HTMLAnchorElement> e.target).href = url;
    // return true;
  }
  /**
   * Анимация движения текста, если название канала не помещается в рамках окна.
   * @param element 
   */
  channel_focus(element:HTMLLIElement){
    const div:HTMLSpanElement = element.querySelector("div"),
          delta:number =  div.scrollWidth - div.clientWidth;
    if(delta > 10) {
      const span:HTMLSpanElement = element.querySelector("span"),
            speed:number = 30, // Скорость движения букв.
            duration:number = Math.floor((delta/speed)*100)/100;
      span.style.transitionDuration = duration+"s";
      span.style.textIndent = -1*delta + "px";
      setTimeout(()=>{
        span.style.transitionDuration = "0.3s";
        span.style.textIndent = "0px";
        setTimeout(() => {
            if(document.activeElement == element){
              this.channel_focus(element);
            }
          }, 1000);
      }, duration*1000+1000);
    }
  }
  /**
   * Остановка анимации движения текста
   * @param element 
   */
  channel_blur(element:HTMLLIElement){
    const span:HTMLSpanElement = element.querySelector("span");
    if( span.style.textIndent != "") {
      span.style.transitionDuration = "0.3s";
      span.style.textIndent = "0px";
    }
  }
  /**
   * Переименование группы
   */
  group_rename(group:ChannelsGroup){
    if(group.id !== null) {
      this.changeGroup.emit(group);
    }
  }
  /**
   * Указание отображаемой группы
   */
  group_select(group:ChannelsGroup){
    this._group_selected = group;
    this.selectedGroup.emit(group);
    this.channels_filter({group_id: group.id})
    // Скрываем поисковую строку канала
    this.showChannelsSearchInput = false;
  }

  /**
   * Добавление новой группы
   */
  group_add(e:MouseEvent){
    let max = 0, group:ChannelsGroup = {id: max+1, name: "Группа", deleted: true, added: true};
    this.groups.map(item=>{ max = max < item.id ? item.id : max });
    group.id =  max+1;
    this.groups.splice(this.groups.length -1, 0, group );

    // Анимация удаления группы
    setTimeout(() => {
      group.deleted = false;
    }, 50);

    // Анимация кнопки добавления канала
    const element = <HTMLParagraphElement>e.currentTarget;
    element.classList.add("animation");
    setTimeout(() => {
      group.added = false;
      element.classList.remove("animation");
    }, 500);

    // Прокручиваем блок в конец списка.
    const groupsBlock = <HTMLElement>this.groupsBlock.nativeElement;
    try {
      groupsBlock.querySelector("span:last-child").scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    } catch (error) {
      groupsBlock.scrollTop = groupsBlock.scrollHeight - groupsBlock.clientHeight;
    }

    this.group_selected = this.groups[this.groups.length-2];
  }
  /**
   * Событие удаление группы
   * @param group ChannelsGroup
   */
  group_remove_event(group:ChannelsGroup){
    this.groupRemoveEvent.emit(group);
  }
  /**
   * Удаление группы
   * @param group ChannelsGroup
   */
  group_remove(group:ChannelsGroup){
      group.deleted = true;
      setTimeout(() => {
        this.channels.map(channel=>{ if(channel.group_id === group.id) {
          channel.group_id = null;
        }});
        this.groups.splice(this.groups.indexOf(group), 1);
        this.group_selected = this.groups[0];
        this._spatialNavigation.reset();
      }, 500);
  }
  /**
   * Начало передвижения группы
   * @param group 
   * @param e 
   */
  group_dragstart(group:ChannelsGroup, e:DragEvent) {
    e.dataTransfer.setData("text/plain", ""); // Обязательно для Mozilla
    if(group.id !== null){ 
      this.group_moved = group;
      setTimeout(() => { // Делаем очень малую задержку, так как перемещаемый объект сдвигается по X и если хватать объект за определенную область, перемещение сразу же останавливается.
        group.move = true;
      }, 10);
    }
  }
  /**
   * Событие срабатывающее, когда на группу бросается канал.
   * Присваиваем перемещаемый канал этой группе.
   */
  group_drop(group: ChannelsGroup) {
    if(this.channels_moved.length && this.channels_moved[0].group_id !== group.id){
      let copyChannels:Channel[] = [];
      this.channels_moved.forEach((channel:Channel)=>{
        channel.deleted = true;
        copyChannels.push(channel);
      });
      setTimeout(() => {
        copyChannels.forEach((channel:Channel)=>{
          channel.deleted = false;
          channel.group_id = group.id;
          // Удаляем каналы из отображаемого списка.
          this.channelsFiltered.splice(this.channelsFiltered.indexOf(channel), 1);
        });
        copyChannels = [];
      }, 500);
    }
  }
  /**
   * Событие после завершения перемещения группы.
   */
  group_dragend(){
    if(this.group_moved){
      const group_moved = this.group_moved;
      group_moved.move = false;
      group_moved.moved = true;
      this.group_moved = null;
      setTimeout(() => {
        group_moved.moved = false;
        this._spatialNavigation.reset();
      }, 500);
    }
    this.group_over = null;
  }
  /**
   * Событие срабатывает, когда над группой переносят, какой-то перемещаемый объект.
   * @param i 
   */
  group_dragenter(i:number, e:MouseEvent) {
      e.preventDefault();
      this.group_over = i;
      if(this.group_moved && this.group_moved != this.groups[i] && this.groups.length != i+1) {
        const index = this.groups.indexOf(this.group_moved);
        const group = this.group_moved;
        this.groups.splice(index, 1);
        this.groups.splice(i+1,0,group);
      }
  }
  /**
   * Необходимо для того чтобы работал Drag'nDrop
   */
  group_dragover(e:DragEvent) {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  }
  /**
   * Выделение группы каналов, использованием CTRL и Shift
   * @param e 
   * @param channel 
   */
  click_grouping(e:MouseEvent, channel:Channel){
    if(e.shiftKey || this.shiftKey){
      if(this.channels_moved.length){ // Если блок перемещаемых каналов пуст, тогда добавляем один выделенный канал.
        let prevIndex = this.channels.indexOf(this.channels_moved[this.channels_moved.length-1]),
        currIndex = this.channels.indexOf(channel);
        if(prevIndex > currIndex) {
          const copyCurrIndex = currIndex;
          currIndex = prevIndex;
          prevIndex = copyCurrIndex;
        }
        for (let i = prevIndex; i <= currIndex; i++) {
          // Выбираем только те каналы, которые есть в отображаемом списке.
          if(this.channelsFiltered.indexOf(this.channels[i]) > -1){
            this.add_channels_moved(this.channels[i]);
            this.channels[i].move = true;
          }
        }
      } else {
        this.add_channels_moved(channel);
        channel.move = true;
      }
    } 
    else if(e.ctrlKey || this.ctrlKey){
      const presentedIndex = this.channels_moved.indexOf(channel);
      if(presentedIndex < 0){
        this.add_channels_moved(channel);
        channel.move = true;
      } else {
        this.channels_moved.splice(presentedIndex,1);
        channel.move = false;
      }
    }

  }

  /**
   * Добавление в блок перемещаемых каналов, без повторов.
   * @param channel 
   */
  private add_channels_moved(channel:Channel){
    if(this.channels_moved.indexOf(channel) === -1){
      this.channels_moved.push(channel);
      return true;
    } else {
      return false;
    }
  }
  /**
   * Событие нажатия кнопки очистки корзины
   */
  empty_trash_event(event:MouseEvent){
    event.stopPropagation();
    this.emptyTrashEvent.emit(null);
  }
  /**
   * Полная очистка корзины.
   * Необходимо присвоить данному свойству, значение true
   */
  empty_trash() {
    const trash = [];
      // Сразу удалять нельзя, так как меняется индексация масива
      this.channels.forEach((channel:Channel)=>{
        if(channel.group_id === null){
          trash.push(channel);
        }
      });
      trash.forEach((channel:Channel)=>{
        this.channels.splice(this.channels.indexOf(channel), 1);
      })
  }
  /**
   * Вывести программу передач на день.
   * @param channel Channel
   */
  epg_day(channel:Channel){
    this.epgDayChannel.emit(channel);
  }
}

/**
 * Каналы
 */
export interface Channel {
  url:string;
  group_id:number|null;
  name:string;
  /**
   * Логотип канала
   */
  icon:string;
  /**
   * Идентификатор для EPG
   */
  tvg_id:string;
  /**
   * Массив данных для EPG. Первый элемент в массиве, является программой передач на текущий момент.
   */
  epg?:EPG_list[];
  /**
   * Индикатор перемещения канала
   */
  move?:boolean;
  /**
   * Для анимации перемещения канала.
   */
  moved?:boolean;
  /**
   * Для анимации удаления канала
   */
  deleted?:boolean;
  /**
   * Для анимации добавления канала.
   */
  added?:boolean;
  /**
   * Дополнительные атрибуты используемые для канала.
   * @example #EXTINF:-1 group-title="Русские" tvg-id="pervy" tvg-logo="http://ip.tv/ch/20105.png" catchup="shift" catchup-days="7" ,Первый канал HD
   */
  additionalAttributes?:string;
}
/**
 * Группы для каналов
 */
export interface ChannelsGroup {
  id:number;
  name:string;
  /**
   * Индикатор перемещения группы
   */
  move?:boolean;
  /**
   * Для анимации перемещения группы.
   */
  moved?:boolean;
  /**
   * Для анимации удаления группы
   */
  deleted?:boolean;
   /**
   * Для анимации добавления группы.
   */
  added?:boolean;
  /**
   * Загружалась ли программа передач для данной группы.
   */
  epg?:boolean;
}